import { useState, useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {Loader, Empty, RequestFourthIcon} from 'common/components'
import {RequestsList, useGetRequests} from '..'
import {ButtonKeyType, IButtonProps, ButtonOptions, BUTTONS_PROPS_ALL} from './Requests.all.filter'

const BUTTONS_PROPS: IButtonProps[] = BUTTONS_PROPS_ALL.map((x:IButtonProps) => ({...x}))
export default function ApprovedRequests() {
  const location = useLocation()
  const [btnKey, setBtnKey] = useState<ButtonKeyType>(BUTTONS_PROPS[0].key)
  const {data: requests, isRefetching} = useGetRequests(btnKey)
  const {data: data0} = useGetRequests(BUTTONS_PROPS[0].key)
  const {data: data1} = useGetRequests(BUTTONS_PROPS[1].key)
  const {data: data2} = useGetRequests(BUTTONS_PROPS[2].key)
  const data:any = [data0, data1, data2]
  const buttons = BUTTONS_PROPS.map((x:IButtonProps, index:number) => ({
    key: x.key,
    label: `${x.label} (${data[index]?.length ?? '...'})`,
  }))

  useLayoutEffect(() => {
    if (!!location?.state?.filterKey) {
      if(location.state.filterKey !== btnKey) {
        setBtnKey(location.state.filterKey)
      }
      location.state.filterKey = null;
    }
  }, [location, btnKey])
  
  return (
    <>
      <ButtonOptions buttons={buttons} currentBtnKey={btnKey} onClick={setBtnKey} />
      {
        (!requests) ? <Loader />
        :
        (requests.length === 0) ?
        <Empty icon={<RequestFourthIcon />} title="Loan requests" />
        :
        <RequestsList urlPrefix='loan' tag='loan' items={requests} loading={isRefetching} />
      }
    </>
  )
}
